e4.dealersearch = {
    debug: false,
    dependencies: {
        googleMaps: {
            timeout: null,
            dfd: null,
            load: function () {
                if ( e4.dealersearch.dependencies.googleMaps.dfd === null ) {
                    e4.dealersearch.dependencies.googleMaps.dfd = jQuery.Deferred();
                    jQuery.when( e4.dealersearch.dependencies.googleMaps.dfd ).then( e4.dealersearch.dependencies.googleMaps.callback, function () {
                        e4.util.debug( [
                            'googleMaps.load',
                            'fail callback',
                            e4.dealersearch.dependencies.googleMaps.dfd.state()
                        ], e4.dealersearch.debug );
                    } );
                }
                var domScriptGM = document.createElement( 'script' ),
                    domScriptFirst = document.getElementsByTagName( 'script' )[ 0 ];
                domScriptGM.src = '//maps.googleapis.com/maps/api/js?key=' + e4.dealersearch.googleMapsApiKey + '&callback=' + 'e4.dealersearch.dependencies.googleMaps.dfd.resolve';
                domScriptFirst.parentNode.insertBefore( domScriptGM, domScriptFirst );
                e4.dealersearch.dependencies.googleMaps.timeout = setTimeout( e4.dealersearch.dependencies.googleMaps.dfd.reject, e4.settings.require.timeout );
                return e4.dealersearch.dependencies.googleMaps.dfd.promise();
            },
            callback: function () {
                e4.util.debug( [
                    'googleMaps.load',
                    'done callback',
                    e4.dealersearch.dependencies.googleMaps.dfd.state()
                ], e4.dealersearch.debug );
                clearTimeout( e4.dealersearch.dependencies.googleMaps.timeout );
                e4.dealersearch.dependencies.googleMaps.timeout = null;
                e4.dealersearch.geocoder = new google.maps.Geocoder();
            }
        },
        jQueryUImap: {
            load: function () {
                return e4.util.require.js( e4.settings.require.jQueryUImap, function () {
                    e4.util.debug( [
                        'jQueryUImap.callback',
                        'dfd state',
                        e4.settings.require.jQueryUImap.promise.state()
                    ], e4.dealersearch.debug );
                    var jMap = jQuery( '.js-e-dealersearch' ).find( '.js-e-dealersearch-googlemap' );
                    jQuery.extend( e4.dealersearch.map, {
                        build: function ( objMapSettings, fnCallback ) {
                            return jMap.gmap( objMapSettings, fnCallback );
                        },
                        get: function () {
                            return jMap.gmap( 'get', 'map' );
                        },
                        refresh: function () {
                            jMap.gmap( 'refresh' );
                        },
                        showInfoWindow: function ( objMarker ) {
                            jMap.gmap( 'openInfoWindow', {
                                'content': e4.dealersearch.markers.getInfoWindowContent( objMarker )
                            }, objMarker );
                        }
                    } );
                    jQuery.extend( e4.dealersearch.clusterer, {
                        get: function () {
                            return jMap.gmap( 'get', 'MarkerClusterer' );
                        },
                        set: function ( objMarkerClusterer ) {
                            return jMap.gmap( 'set', 'MarkerClusterer', objMarkerClusterer );
                        }
                    } );
                } );
            }
        },
        markerClusterer: {
            load: function () {
                return e4.util.require.js( e4.settings.require.markerClusterer, function () {
                    e4.util.debug( [
                        'markerClusterer.callback',
                        'dfd state',
                        e4.settings.require.markerClusterer.promise.state()
                    ], e4.dealersearch.debug );
                } );
            }
        },
        handlebars: {
            load: function () {
                return e4.util.require.js( e4.settings.require.handlebars, function () {
                    e4.util.debug( [
                        'handlebars.callback',
                        'dfd state',
                        e4.settings.require.handlebars.promise.state()
                    ], e4.dealersearch.debug );
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-typeahead-footer #js-e-handlebars-tmpl-typeahead-pending #js-e-handlebars-tmpl-googlemap-infowindow #js-e-handlebars-tmpl-marker-list' );
                } );
            }
        },
        typeahead: {
            load: function () {
                return e4.util.require.js( e4.settings.require.typeahead, function () {
                    e4.util.debug( [
                        'typeahead.callback',
                        'dfd state',
                        e4.settings.require.typeahead.promise.state()
                    ], e4.dealersearch.debug );
                    e4.dealersearch.form.init();
                } );
            }
        }
    },
    init: function () {
        var jDealersearch = jQuery( '.js-e-dealersearch' );
        if ( jDealersearch.length === 1 ) {
            e4.dealersearch.googleMapsApiKey = jDealersearch.data( 'googleMapsApiKey' );
            e4.dealersearch.unitSystem = jDealersearch.data( 'unitSystem' );
            e4.dealersearch.dfd = e4.dealersearch.loadDependenciesAndDealers();
            e4.dealersearch.event = e4.util.registerEvents( 'loaded', 'dealersearch' );
        }
    },
    loadDependenciesAndDealers: function () {
        return jQuery.when.apply( jQuery, [
            e4.dealersearch.dependencies.googleMaps.load(),
            e4.dealersearch.dependencies.markerClusterer.load(),
            e4.dealersearch.dependencies.jQueryUImap.load(),
            e4.dealersearch.dependencies.typeahead.load(),
            e4.dealersearch.dependencies.handlebars.load(),
            e4.dealersearch.loadDealers()
        ] ).then( function () {
            e4.dealersearch.map.init();
            e4.util.debug( [
                'loadDependenciesAndDealers',
                'done callback'
            ], e4.dealersearch.debug );
        }, function () {
            e4.util.debug( [
                'loadDependenciesAndDealers',
                'fail callback'
            ], e4.dealersearch.debug );
        } );
    },
    ajax: function ( objAjaxSettings, fnCallback ) {
        var _objAjaxSettings = {
            url: e4.settings.dealersearch.url,
            data: jQuery( '.js-e-dealersearch-form' ).serialize(),
            dataType: 'json',
            cache: false
        };
        if ( objAjaxSettings !== null ) {
            _objAjaxSettings = jQuery.extend( _objAjaxSettings, objAjaxSettings );
        }
        return jQuery.ajax( _objAjaxSettings ).done( function ( jsonData ) {
            e4.dealersearch.data = jsonData;
            e4.dealersearch.handleFacetFilters();
            e4.util.debug( [
                'e4.dealersearch.ajax',
                'done callback'
            ], e4.dealersearch.debug );
            if ( typeof fnCallback === 'function' ) {
                fnCallback.call();
            }
        } );
    },
    handleFacetFilters: function () {
        var domSelectFilters = document.querySelector( '.js-e-dealersearch-type' ),
            availableFilters = e4.dealersearch.data.dealerTypes;
        if ( domSelectFilters !== null ) {
            [].forEach.call( domSelectFilters, function ( domOption ) {
                if ( domOption.value !== '' ) {
                    domOption.disabled = availableFilters.indexOf( domOption.value.replace( ' ', '+' ) ) === -1;
                }
            } );
        }

    },
    loadDealers: function () {
        return e4.dealersearch.ajax( null );
    },
    reloadDealers: function ( fnCallback ) {
        return e4.dealersearch.ajax( null, function () {
            if ( typeof fnCallback === 'function' ) {
                fnCallback.call();
            }
            e4.dealersearch.markers.removeFromClusterer();
            e4.dealersearch.markers.init();
            e4.dealersearch.list.syncWithMap();
        } );
    },
    setCountryAndReloadDealers: function () {
        var gmMap = e4.dealersearch.map.get(),
            xhrDealers = e4.dealersearch.ajax( null );
        e4.dealersearch.resetAddress();
        e4.dealersearch.markers.removeFromClusterer();
        e4.util.debug( [
            'setCountryAndReloadDealers(' + e4.dealersearch.getCountryCode() + ')',
            'gmMap binding bounds_changed'
        ], e4.dealersearch.debug );
        gmMap.addListener( 'bounds_changed', function () {
            e4.util.debug( [
                'setCountryAndReloadDealers(' + e4.dealersearch.getCountryCode() + ')',
                'gmMap clearListeners bounds_changed'
            ], e4.dealersearch.debug );
            google.maps.event.clearListeners( gmMap, 'bounds_changed' );
            xhrDealers.done( function () {
                e4.util.debug( [
                    'setCountryAndReloadDealers(' + e4.dealersearch.getCountryCode() + ')',
                    'xhrDealers done',
                    'markers.init'
                ], e4.dealersearch.debug );
                e4.dealersearch.markers.init();
                e4.dealersearch.list.syncWithMap();
            } );
        } );
        e4.dealersearch.map.setBoundsFromCountry();
        return xhrDealers;
    },
    getCountryCode: function () {
        return jQuery( '.js-e-dealersearch-country' ).val();
    },
    setCountryCode: function ( strCountryCode ) {
        e4.util.debug( [
            'setAddress',
            strCountryCode
        ], e4.dealersearch.debug );
        return jQuery( '.js-e-dealersearch-country' ).val( strCountryCode ).trigger( 'change' );
    },
    getAddress: function () {
        return e4.dealersearch.address;
    },
    setAddress: function ( objAddress ) {
        e4.util.debug( [
            'setAddress',
            objAddress
        ], e4.dealersearch.debug );
        if ( objAddress !== null ) {
            e4.dealersearch.form.setAddressInput( objAddress.formatted_address );
        }
        e4.dealersearch.address = objAddress;
        e4.dealersearch.markers.sort();
    },
    resetAddress: function () {
        e4.dealersearch.form.clearAddressInput();
        e4.dealersearch.setAddress( null );
    },
    searchByAddress: function ( objAddress ) {
        e4.dealersearch.setAddress( objAddress );
        e4.dealersearch.map.get().fitBounds( e4.dealersearch.map.getBoundsByAddress( objAddress ) );
        e4.dealersearch.map.fitResults();
        // TODO: Move to gtm namespace
        e4.gtm.pushDataLayer( {
            'eventCategory': 'Forhandlersøgning',
            'eventAction': objAddress.formatted_address,
            'eventLabel': location.pathname,
            'eventValue': 0,
            'eventInteraction': false,
            'event': 'track-ga-event'
        } );
        //New GA4
        e4.gtm.pushDataLayer( {
            'ga4EventName': 'Forhandlersøgning',
            'ga4EventParameter1': objAddress.formatted_address,
            'ga4EventParameter2': location.pathname,
            'event': 'track-ga4-event'
        } );        
    },
    geoLocation: {
        get: function () {
            navigator.geolocation.getCurrentPosition( function ( objPosition ) {
                e4.dealersearch.geocoder.geocode( {
                    location: {
                        lat: objPosition.coords.latitude,
                        lng: objPosition.coords.longitude
                    }
                }, function ( arrAddresses, strStatus ) {
                    if ( strStatus === google.maps.GeocoderStatus.OK ) {
                        jQuery.each( arrAddresses[ 0 ].address_components, function ( intIndex, address_component ) {
                            jQuery.each( address_component.types, function ( intIndex, address_type ) {
                                if ( address_type === 'country' ) {
                                    if ( address_component.short_name === e4.dealersearch.getCountryCode() ) {
                                        e4.util.debug( [
                                            'geoLocation.get',
                                            'geo country is current country.',
                                            'searching for address',
                                            arrAddresses[ 0 ]
                                        ], e4.dealersearch.debug );
                                        e4.dealersearch.searchByAddress( arrAddresses[ 0 ] );
                                        jQuery( '.js-e-dealersearch-address-input' ).typeahead( 'close' );
                                    }
                                    else {
                                        e4.util.debug( [
                                            'geoLocation.get',
                                            'geo country different from current country.',
                                            'changing country to',
                                            address_component.short_name,
                                            arrAddresses[ 0 ]
                                        ], e4.dealersearch.debug );
                                        if ( jQuery( '.js-e-cart' ).length === 0 ) {
                                            e4.dealersearch.setCountryCode( address_component.short_name );
                                        }
                                        else {
                                            e4.dealersearch.searchByAddress( arrAddresses[ 0 ] );
                                            jQuery( '.js-e-dealersearch-address-input' ).typeahead( 'close' );
                                        }
                                    }
                                }
                            } );
                        } );
                    }
                    else {
                        // TODO: e4.debug
                        e4.dealersearch.resetAddress();
                        e4.dealersearch.map.logError( strStatus );
                    }
                } );
            }, function ( error ) {
                // TODO: Move to gtm namespace
                e4.gtm.pushDataLayer( {
                    'eventCategory': 'navigator.geolocation.getCurrentPosition',
                    'eventAction': error.code + ': ' + error.message,
                    'eventLabel': location.pathname,
                    'eventValue': 0,
                    'eventInteraction': false,
                    'event': 'track-ga-event'
                } );
            } );
        }
    },
    form: {
        init: function () {
            e4.dealersearch.address = null;
            e4.dealersearch.form.bindEvents();
        },
        bindEvents: function () {
            jQuery( '.js-e-dealersearch-form' ).on( 'submit', function ( event ) {
                event.preventDefault();
                var jSuggestionFirst = jQuery( event.target ).find( '.js-e-dealersearch-suggestions' ).find( '.tt-selectable' ).first();
                if ( jSuggestionFirst.length === 1 ) {
                    jSuggestionFirst.trigger( 'click' );
                }
                else if ( jSuggestionFirst.length === 0 ) {
                    e4.dealersearch.geoLocation.get();
                }
            } ).on( 'click', '.js-e-dealersearch-submit', function ( event ) {
                jQuery( event.target.form ).triggerHandler( 'submit' );
            } ).on( 'click', '.js-e-dealersearch-geolocate', function ( event ) {
                event.preventDefault();
                e4.dealersearch.geoLocation.get();
            } );
            jQuery( '.js-e-dealersearch-type' ).on( 'change', function () {
                e4.dealersearch.reloadDealers();
            } );
            jQuery( '.js-e-dealersearch-country' ).on( 'change', function () {
                jQuery( '.js-e-dealersearch-type' ).prop( 'selectedIndex', 0 );
                e4.dealersearch.setCountryAndReloadDealers();
            } );
            jQuery( '.js-e-dealersearch-address-input' ).on( 'keydown', function ( event ) {
                if ( event.keyCode === 13 ) {
                    var jSuggestions = jQuery( event.target.form ).find( '.js-e-dealersearch-suggestions' ),
                        jSuggestionActive = jSuggestions.find( '.tt-selectable' ).filter( '.active' );
                    if ( jSuggestionActive.length === 0 && jSuggestions.css( 'display' ) === 'block' ) {
                        jQuery( event.target.form ).triggerHandler( 'submit' );
                    }
                    else if ( jSuggestionActive.is( '.js-e-dealersearch-geolocate' ) === true ) {
                        jSuggestionActive.trigger( 'click' );
                    }
                }
            } ).on( 'focus input', function () {
                e4.dealersearch.form.hidePlaceholder();
            } ).on( 'blur', function ( event ) {
                if ( event.target.value === '' ) {
                    e4.dealersearch.form.showPlaceholder();
                    e4.dealersearch.resetAddress();
                }
            } );
            jQuery( '.js-e-dealersearch-address-input' ).typeahead( {
                hint: true,
                highlight: true,
                minLength: 0,
                classNames: {
                    wrapper: 'e-dealersearch-typeahead-wrapper js-e-dealersearch-typeahead-wrapper w-100',
                    input: 'js-e-dealersearch-address-input', // https://github.com/twitter/typeahead.js/issues/677#issuecomment-48807067
                    menu: 'js-e-dealersearch-suggestions e-dealersearch-suggestions dropdown-menu',
                    suggestion: 'js-e-dealersearch-suggestions-item dropdown-item',
                    open: 'open',
                    cursor: 'active',
                    highlight: 'active'
                }
            }, {
                name: 'espresso',
                display: 'formatted_address',
                limit: 8,
                async: true,
                source: function ( strQuery, fnSyncResults, fnAsyncResults ) {
                    e4.dealersearch.form.getSuggestions( strQuery, function ( arrAddresses ) {
                        fnAsyncResults( arrAddresses );
                    } );
                },
                templates: {
                    pending: function ( jsonData ) {
                        return e4.handlebars.tmpl.typeaheadPending( jsonData );
                    },
                    footer: function ( jsonData ) {
                        return e4.handlebars.tmpl.typeaheadFooter( jsonData );
                    }
                }
            } ).on( 'typeahead:autocomplete typeahead:select', function ( event, objAddress ) {
                if ( objAddress !== undefined ) {
                    e4.dealersearch.searchByAddress( objAddress );
                    jQuery( event.target ).typeahead( 'close' );
                }
            } );
        },
        getSuggestions: function ( strAddress, fnAsyncResults ) {
            e4.dealersearch.geocoder.geocode( {
                address: strAddress,
                componentRestrictions: {
                    country: e4.dealersearch.getCountryCode() //https://en.wikipedia.org/wiki/ISO_3166-1#Current_codes
                }
            }, function ( arrAddresses, strStatus ) {
                if ( strStatus === google.maps.GeocoderStatus.OK ) {
                    arrAddresses = arrAddresses.filter( function ( objAddress ) {
                        return objAddress.address_components[ 0 ].types[ 0 ] !== 'country';
                    } );
                    fnAsyncResults( arrAddresses );
                }
                else {
                    e4.dealersearch.map.logError( strStatus );
                }
            } );
        },
        setAddressInput: function ( strAddress ) {
            jQuery( '.js-e-dealersearch-address-input' ).typeahead( 'val', strAddress );
            e4.dealersearch.form.hidePlaceholder();
        },
        clearAddressInput: function () {
            jQuery( '.js-e-dealersearch-address-input' ).typeahead( 'val', '' );
            e4.dealersearch.form.showPlaceholder();
        },
        showPlaceholder: function () {
            jQuery( '.js-e-dealersearch-address-input-placeholder' ).removeClass( 'is-hidden' );
        },
        hidePlaceholder: function () {
            jQuery( '.js-e-dealersearch-address-input-placeholder' ).addClass( 'is-hidden' );
        }
    },
    map: {
        init: function () {
            e4.dealersearch.map.build( {
                center: e4.dealersearch.map.getCenterByCountry(),
                zoom: e4.dealersearch.map.getZoomByCountry(),
                mapTypeControl: false,
                scrollwheel: false,
                styles: e4.dealersearch.map.getStyles()
            } ).on( 'init', function () {
                e4.dealersearch.clusterer.init();
                e4.dealersearch.markers.init();
                e4.dealersearch.list.init();
                e4.dealersearch.map.bindEvents();
                e4.dealersearch.map.setBoundsFromCountry();
            } );
            jQuery( document ).trigger( e4.dealersearch.event.loaded );
        },
        bindEvents: function () {
            e4.dealersearch.map.get().addListener( 'idle', function () {
                e4.util.debug( 'map idle', e4.dealersearch.debug );
                //if ( e4.util.getBreakPoint() !== 'xs' && e4.util.getBreakPoint() !== 'sm' ) {
                e4.dealersearch.list.syncWithMap();
                //}
            } );
            jQuery( window ).on( 'resize', e4.util.debounce( e4.dealersearch.map.refresh, e4.settings.debounceDelay.resize ) );
        },
        get: function () {
            // This function gets defined in require.js jQueryMapUI callback;
        },
        refresh: function () {
            // This function gets defined in require.js jQueryMapUI callback;
        },
        build: function ( objMapSettings, fnCallback ) {
            // This function gets defined in require.js jQueryMapUI callback;
            // Dummy use of argument to make JSLint happy;
            console.log( objMapSettings, fnCallback );
        },
        showInfoWindow: function ( objMarker ) {
            // This function gets defined in require.js jQueryMapUI callback;
            // Dummy use of argument to make JSLint happy;
            console.log( objMarker );
        },
        setBoundsFromCountry: function () {
            var strCountryCode = e4.dealersearch.getCountryCode();
            // If custom settings for center and zoom are present.
//            if ( e4.settings.dealersearch.country[ strCountryCode ] !== undefined || strCountryCode === '' ) {
//                e4.util.debug( ['Setting center and zoom for country(' + strCountryCode + ') from global settings.'], e4.dealersearch.debug );
//                var gmMap = e4.dealersearch.map.get();
//                gmMap.setCenter( e4.dealersearch.map.getCenterByCountry() );
//                gmMap.setZoom( e4.dealersearch.map.getZoomByCountry() );
//            }
//            // If no center and zoom settings are present, use geocode to get values from current country.
//            else {
                e4.dealersearch.geocoder.geocode( {
                    address: '',
                    componentRestrictions: {
                        country: strCountryCode //https://en.wikipedia.org/wiki/ISO_3166-1#Current_codes
                    }
                }, function ( arrAddresses, strStatus ) {
                    if ( strStatus === google.maps.GeocoderStatus.OK ) {
                        var objBoundsAddress = e4.dealersearch.map.getBoundsByAddress( arrAddresses[ 0 ] );
                        
                        
                        console.log(arrAddresses);
                        
                        if(arrAddresses.Placemark !== undefined){
                            var north = arrAddresses.Placemark[0].ExtendedData.LatLonBox.north;
                            var south = arrAddresses.Placemark[0].ExtendedData.LatLonBox.south;
                            var east  = arrAddresses.Placemark[0].ExtendedData.LatLonBox.east;
                            var west  = arrAddresses.Placemark[0].ExtendedData.LatLonBox.west;

                            objBoundsAddress = new google.maps.LatLngBounds(new google.maps.LatLng(south, west),
                                    new google.maps.LatLng(north, east));
                        }

                        

                        var gmMap = e4.dealersearch.map.get();
                        
                        e4.util.debug( [
                            'Setting center and bounds for country(' + strCountryCode + ') from Maps API',
                            objBoundsAddress
                        ], e4.dealersearch.debug );
                        
                        gmMap.fitBounds( objBoundsAddress );
                        // gmMap.setZoom( gmMap.getZoom() + 1 );
                    }
                    else {
                        e4.dealersearch.map.logError( strStatus );
                    }
                } );
            //}
        },
        getCenterByCountry: function () {
            var strCountryCode = e4.dealersearch.getCountryCode();
            if ( e4.settings.dealersearch.country[ strCountryCode ] !== undefined ) {
                return new google.maps.LatLng( e4.settings.dealersearch.country[ strCountryCode ].center );
            }
            else {
                return new google.maps.LatLng( {
                    lat: 0,
                    lng: 0
                } );
            }
        },
        getZoomByCountry: function () {
            var strCountryCode = e4.dealersearch.getCountryCode();
            if ( e4.settings.dealersearch.country[ strCountryCode ] !== undefined ) {
                return e4.settings.dealersearch.country[ strCountryCode ].zoom;
            }
            else {
                return 2;
                // https://developers.google.com/maps/documentation/static-maps/intro#Zoomlevels
                // 1: World
                // 5: Landmass/continent
                // 10: City
                // 15: Streets
                // 20: Buildings
            }
        },
        getBoundsByAddress: function ( objAddress ) {
            var objAddressBounds;
            if ( objAddress.geometry.viewport !== undefined ) {
                objAddressBounds = objAddress.geometry.viewport;
            }
            else if ( objAddress.geometry.bounds !== undefined ) {
                objAddressBounds = objAddress.geometry.bounds;
            }
            else {
                objAddressBounds = new google.maps.LatLngBounds();
                objAddressBounds.extend( objAddress.geometry.location );
            }
            return objAddressBounds;
        },
        getMarkersInBounds: function () {
            var objMapBounds = e4.dealersearch.map.get().getBounds(),
                arrMarkersInBounds = [];
            jQuery.each( e4.dealersearch.data.markers, function ( intIndex, objMarker ) {
                if ( objMapBounds.contains( objMarker.getPosition() ) === true ) {
                    arrMarkersInBounds.push( objMarker );
                }
            } );
            return arrMarkersInBounds;
        },
        extendBoundsToMarker: function ( objMarker ) {
            var objMapBounds = e4.dealersearch.map.get().getBounds();
            objMapBounds.extend( objMarker.getPosition() );
            e4.dealersearch.map.get().fitBounds( objMapBounds );
        },
        fitResults: function () {
            e4.util.debug( [
                'Extending bounds to fit search min markers.'
            ], e4.dealersearch.debug );
            var intMapZoom = e4.dealersearch.map.get().getZoom();
            // Make sure that map zoom is within min/max settings.
            if ( intMapZoom > e4.settings.dealersearch.results.zoom.max ) {
                // console.log( 'max', intMapZoom, e4.settings.dealersearch.results.zoom.max )
                e4.dealersearch.map.get().setZoom( e4.settings.dealersearch.results.zoom.max );
            }
            else if ( intMapZoom < e4.settings.dealersearch.results.zoom.min ) {
                // console.log( 'min', intMapZoom, e4.settings.dealersearch.results.zoom.min )
                e4.dealersearch.map.get().setZoom( intMapZoom + 1 );
            }
            // If no markers are in bounds, then extend bounds to closest marker.
            if ( e4.dealersearch.map.getMarkersInBounds().length === 0 ) {
                e4.dealersearch.map.extendBoundsToMarker( e4.dealersearch.data.markers[ 0 ] );
            }
            // While markers in bounds is below min result setting, extend bounds to closest marker.
            for ( var m = e4.dealersearch.map.getMarkersInBounds().length; m <= e4.settings.dealersearch.results.min; m++ ) {
                // Break if there is no more markers to show.
                if ( e4.dealersearch.data.markers.length > m ) {
                    // If marker is within calculated sensitivity distance to previous marker, extend bounds to marker.
                    if ( m > 0 && e4.dealersearch.data.markers[ m ].distanceToAddress < e4.dealersearch.data.markers[ m - 1 ].distanceToAddress * ( 1 + Math.pow( e4.settings.dealersearch.results.sensitivity, m ) ) ) {
                        e4.dealersearch.map.extendBoundsToMarker( e4.dealersearch.data.markers[ m ] );
                        // console.log('added',e4.dealersearch.data.markers[e4.dealersearch.getCountryCode][ m
                        // ].data.name);
                    }
                    else {
                        break;
                    }
                }
                else {
                    break;
                }
            }
        },
        getStyles: function () {
            var arrResult = [];
            if ( jQuery.isArray( e4.settings.dealersearch.map.styles ) === true ) {
                arrResult = e4.settings.dealersearch.map.styles;
            }
            else {
                e4.util.debug( 'Can not find styles for map, using default styles.', e4.dealersearch.debug );
            }
            return arrResult;
        },
        logError: function ( strError ) {
            e4.util.debug( [
                'Google Maps Error',
                strError
            ], e4.dealersearch.debug );
            // TODO: Move to gtm namespace
            e4.gtm.pushDataLayer( {
                'eventCategory': 'Google Maps Error',
                'eventAction': strError,
                'eventLabel': location.pathname,
                'eventValue': 0,
                'eventInteraction': false,
                'event': 'track-ga-event'
            } );
        }
    },
    clusterer: {
        init: function () {
            e4.dealersearch.clusterer.set( new MarkerClusterer( e4.dealersearch.map.get(), [], {
                averageCenter: true,
                maxZoom: e4.settings.dealersearch.clusterer.maxZoom,
                minimumClusterSize: e4.settings.dealersearch.clusterer.minimumClusterSize,
                imagePath: e4.settings.dealersearch.clusterer.imagePath
            } ) );
        },
        get: function () {
            // This function gets defined in require.js jQueryMapUI callback;
        },
        set: function ( objMarkerClusterer ) {
            // This function gets defined in require.js jQueryMapUI callback;
            // Dummy use of argument to make JSLint happy;
            console.log( objMarkerClusterer );
        }
    },
    markers: {
        init: function () {
            e4.util.debug( 'markers.init', e4.dealersearch.debug );
            e4.dealersearch.markers.build();
            e4.dealersearch.markers.sort();
            e4.dealersearch.markers.addToClusterer();
            e4.dealersearch.markers.bindEvents();
            if ( e4.dealersearch.getAddress() !== null && e4.dealersearch.map.getMarkersInBounds().length === 0 ) {
                e4.dealersearch.map.fitResults();
            }
        },
        build: function () {
            e4.dealersearch.data.markers = [];
            jQuery.each( e4.dealersearch.data.users, function ( intIndex, objUser ) {
                var lat = parseFloat( objUser.lat ),
                    lng = parseFloat( objUser.lng );
                if ( isNaN( lat ) === true || isNaN( lng ) === true || Math.abs( lat ) > 90 || Math.abs( lng ) > 180 ) {
                    e4.util.debug( 'lat/lng  not valid for this objUser: ' + objUser.name + '(' + objUser.id + ')', e4.dealersearch.debug );
                }
                else if ( objUser.countryCode === '' ) {
                    e4.util.debug( 'countryCode is empty for this objUser: ' + objUser.name + '(' + objUser.id + ')', e4.dealersearch.debug );
                }
                else {
                    objUser.distanceToAddress = 0;
                    e4.dealersearch.data.markers.push( new google.maps.Marker( {
                        id: objUser.id,
                        position: new google.maps.LatLng( lat, lng ),
                        icon: e4.dealersearch.markers.getIcon( objUser ),
                        data: objUser
                    } ) );
                }
            } );
        },
        sort: function () {
            if ( e4.dealersearch.getAddress() !== null ) {
                e4.dealersearch.markers.sortByDistanceToAddress();
            }
            else {
                e4.dealersearch.markers.sortByName();
            }
        },
        get: function ( strId ) {
            for ( var m = 0; m < e4.dealersearch.data.markers.length; m++ ) {
                if ( String( e4.dealersearch.data.markers[ m ].id ) === String( strId ) ) {
                    return e4.dealersearch.data.markers[ m ];
                }
            }
            return null;
        },
        bindEvents: function () {
            jQuery.each( e4.dealersearch.data.markers, function ( intIndex, objMarker ) {
                google.maps.event.addListener( objMarker, 'click', function () {
                    e4.dealersearch.map.showInfoWindow( objMarker );
                    // TODO: Move to gtm namespace
                    e4.gtm.pushDataLayer( {
                        'eventCategory': 'Forhandlerkort',
                        'eventAction': objMarker.data.name,
                        'eventLabel': location.pathname,
                        'eventValue': 0,
                        'eventInteraction': false,
                        'event': 'track-ga-event'
                    } );
                    //New GA4
                    e4.gtm.pushDataLayer( {
                        'ga4EventName': 'Forhandlerkort',
                        'ga4EventParameter1': objMarker.data.name,
                        'ga4EventParameter2': location.pathname,
                        'event': 'track-ga4-event'
                    } );                    
                } );
            } );
        },
        addToClusterer: function () {
            if ( e4.dealersearch.data.markers !== undefined && e4.dealersearch.data.markers.length > 0 ) {
                e4.dealersearch.clusterer.get().addMarkers( e4.dealersearch.data.markers );
                e4.util.debug( [
                    'marker.addToClusterer',
                    'Adding markers for country',
                    e4.dealersearch.getCountryCode()
                ], e4.dealersearch.debug );
            }
            else {
                e4.util.debug( [
                    'marker.addToClusterer',
                    'No markers for country(' + e4.dealersearch.getCountryCode() + ') and/or type.'
                ], e4.dealersearch.debug );
            }
        },
        removeFromClusterer: function () {
            e4.util.debug( [
                'marker.removeFromClusterer'
            ], e4.dealersearch.debug );
            e4.dealersearch.clusterer.get().clearMarkers();
        },
        getInfoWindowContent: function ( objMarker ) {
            e4.util.debug( objMarker, true );
            return e4.handlebars.tmpl.googlemapInfowindow( objMarker.data );
        },
        showOnMap: function ( objMarker ) {
            var gmMap = e4.dealersearch.map.get();
            gmMap.panTo( objMarker.getPosition() );
            gmMap.setZoom( e4.settings.dealersearch.results.zoom.max - 1 );
            google.maps.event.trigger( objMarker, 'click' );
        },
        sortByDistanceToAddress: function () {
            e4.util.debug( 'markers.sortByDistanceToAddress', e4.dealersearch.debug );
            var objAddress = e4.dealersearch.getAddress(),
                lat = objAddress.geometry.location.lat(),
                lng = objAddress.geometry.location.lng();
            jQuery.each( e4.dealersearch.data.markers, function ( intIndex, objMarker ) {
                objMarker.data.distanceToAddress = e4.dealersearch.markers.math.getGreatCircleDistance( lat, lng, objMarker.getPosition().lat(), objMarker.getPosition().lng() );
                objMarker.data.distanceToAddressFormatted = e4.dealersearch.markers.math.formatDistance( objMarker.data.distanceToAddress );
            } );
            e4.dealersearch.data.markers.sort( function ( a, b ) {
                return a.data.distanceToAddress - b.data.distanceToAddress;
            } );
        },
        sortByName: function () {
            e4.util.debug( [
                'markers.sortByName'
            ], e4.dealersearch.debug );
            jQuery.each( e4.dealersearch.data.markers, function ( intIndex, objMarker ) {
                objMarker.data.distanceToAddress = 0;
            } );
            e4.dealersearch.data.markers.sort( function ( a, b ) {
                if ( a.data.name < b.data.name ) {
                    return -1;
                }
                if ( a.data.name > b.data.name ) {
                    return 1;
                }
                return 0;
            } );
        },
        getIcon: function ( objUser ) {
            var strReturnValue = '',
                strUserType,
                markerIconFileName;
            if ( jQuery.isArray( objUser.type ) === true ) {
                strUserType = objUser.type.join( e4.settings.dealersearch.marker.typeSeparator );
                markerIconFileName = '';
                if ( e4.settings.dealersearch.marker.iconFileName[ strUserType ] !== undefined ) {
                    markerIconFileName = e4.settings.dealersearch.marker.iconFileName[ strUserType ];
                }
                else {
                    e4.util.debug( 'Can not find icon for user type ' + strUserType + '(' + objUser.id + ') using default icon', e4.dealersearch.debug );
                    markerIconFileName = e4.settings.dealersearch.marker.iconFileNameDefault;
                }
                strReturnValue = e4.settings.dealersearch.marker.iconUrl + markerIconFileName;
            }
            else {
                e4.util.debug( [
                    'Can not find type for user ' + objUser.name + '(' + objUser.id + '). Returning default icon.'
                ], e4.dealersearch.debug );
                markerIconFileName = e4.settings.dealersearch.marker.iconFileNameDefault;
            }
            return strReturnValue;
        },
        math: {
            formatDistance: function ( intNumber ) {
                if ( e4.dealersearch.unitSystem === 'imperial' ) {
                    intNumber = intNumber / 1.609344;
                }
                return e4.util.formatJavascriptNumberToLocaleString( Math.round( intNumber * 100 ) / 100 );
            },
            toRadians: function ( intNumber ) {
                return intNumber * ( Math.PI / 180 );
            },
            getGreatCircleDistance: function ( lat1, lng1, lat2, lng2 ) {
                // https://en.wikipedia.org/wiki/Haversine_formula
                var dLat = e4.dealersearch.markers.math.toRadians( lat2 - lat1 ),
                    dLng = e4.dealersearch.markers.math.toRadians( lng2 - lng1 ),
                    a = Math.sin( dLat / 2 ) * Math.sin( dLat / 2 ) + Math.sin( dLng / 2 ) * Math.sin( dLng / 2 ) * Math.cos( e4.dealersearch.markers.math.toRadians( lat1 ) ) * Math.cos( e4.dealersearch.markers.math.toRadians( lat2 ) );
                return 6371 * ( 2 * Math.atan2( Math.sqrt( a ), Math.sqrt( 1 - a ) ) );
            }
        }
    },
    list: {
        init: function () {
            e4.util.debug( 'list init', e4.dealersearch.debug );
            e4.dealersearch.list.bindEvents();
            //e4.dealersearch.list.syncWithMap();
        },
        bindEvents: function () {
            jQuery( '.js-e-dealersearch-list' ).on( 'click', '.js-e-dealersearch-list-item', function ( event ) {
                e4.dealersearch.markers.showOnMap( e4.dealersearch.markers.get( jQuery( event.currentTarget ).data( 'id' ) ) );
            } ).on( 'click', '.js-e-dealersearch-show-map', function ( event ) {
                event.preventDefault();
                jQuery( '.js-e-dealersearch-googlemap-container' ).addClass( 'is-active' );
                e4.scrollToAnchor.animate( e4.scrollToAnchor.getTarget( '.js-e-dealersearch-googlemap-container' ) );
            } );
        },
        syncWithMap: function () {

            var jsonMarkersInBounds = {
                markers: e4.dealersearch.map.getMarkersInBounds()
            };
            e4.util.debug( 'list syncWithMap', e4.dealersearch.debug );
            if ( jsonMarkersInBounds.markers.length === 0 ) {
                jQuery( '.js-e-dealersearch-list' ).addClass( 'is-empty' ).html( '' );
            }
            else {
                jQuery( '.js-e-dealersearch-list' ).removeClass( 'is-empty' ).html( e4.handlebars.tmpl.markerList( jsonMarkersInBounds ) );
            }

        }
    }
};

